import { httpClient } from "./httpClient";

const getAllHistoryActions = () => {
    return httpClient.get("getAllHistoryActions");
};

export default {
    getAllHistoryActions,
};